import styled from '@emotion/styled';
import { Grid } from '@material-ui/core';
import { Magnetic } from '@mitchell/react.component.ux';
export const StyledContent = styled('div') `
	text-align: justify;
`;
export const StyledActionControlsSection = styled('div') `
	padding: 0 ${Magnetic.spacer24} ${Magnetic.spacer24} ${Magnetic.spacer24};
	box-sizing: inherit;
`;
export const StyledDivImage = styled(Grid) `
	padding-bottom: ${Magnetic.spacer24};
`;
export const StyledDivDefaultImage = styled(Grid, {
    shouldForwardProp: prop => prop !== 'backgroundImage'
})((props) => `
	background: ${Magnetic[props.backgroundImage]} no-repeat center;
	height: 175px;
	width: 100%;
	margin-bottom: ${Magnetic.spacer24};
`);
export const StyledButtonContainer = styled(Grid) `
	margin-bottom: ${Magnetic.spacer06};
`;
export const StyledDivSpacer = styled(Grid) `
	padding-top: ${Magnetic.spacer06};
`;
export const StyledMenuItem = styled(Grid) `
	margin-bottom: ${Magnetic.spacer04};
`;
//# sourceMappingURL=SinglePhotoUploadComponent.style.js.map